export default "__VITE_ASSET__BwxtvT9W__"